import listActions from '../../../modules/courseComment/list/courseCommentListActions'
import CourseCommentService from '../../../modules/courseComment/courseCommentService'
import Errors from '../../../modules/shared/error/errors'
import { i18n } from '../../../i18n'
import { push } from 'redux-first-history'
import Message from '../../../view/shared/message'

const prefix = 'COURSECOMMENT_DESTROY'

const courseCommentDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: courseCommentDestroyActions.DESTROY_STARTED,
      })

      await CourseCommentService.destroyAll([id])

      dispatch({
        type: courseCommentDestroyActions.DESTROY_SUCCESS,
      })

      Message.success(
        i18n('entities.courseComment.destroy.success'),
      )

      dispatch(listActions.doFetchCurrentFilter())

      dispatch(push('/course-comment'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: courseCommentDestroyActions.DESTROY_ERROR,
      })
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: courseCommentDestroyActions.DESTROY_ALL_STARTED,
      })

      await CourseCommentService.destroyAll(ids)

      dispatch({
        type: courseCommentDestroyActions.DESTROY_ALL_SUCCESS,
      })

      if (listActions) {
        dispatch(listActions.doClearAllSelected())
        dispatch(listActions.doFetchCurrentFilter())
      }

      Message.success(
        i18n('entities.courseComment.destroyAll.success'),
      )

      dispatch(push('/course-comment'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: courseCommentDestroyActions.DESTROY_ALL_ERROR,
      })
    }
  },
}

export default courseCommentDestroyActions
